module.exports = __webpack_public_path__ + "static/media/delete.b7891bd4.svg";